module.exports = __webpack_public_path__ + "img/spain-digestive-diseases-male.04f61986.png";